// Normalize a graded-slab label to "<company> <number>" (e.g. "PSA NM-MT 8" -> "PSA 8").
// Accepts a card object (uses .grade / .grading_company) or a raw grade string.
export function gradeLabel(cardOrGrade) {
  if (!cardOrGrade) return "";
  const isObj = typeof cardOrGrade === "object";
  const raw = (isObj ? cardOrGrade.grade || "" : cardOrGrade).toString().trim();
  const company = (isObj && cardOrGrade.grading_company)
    ? cardOrGrade.grading_company
    : (raw.match(/\b(PSA|CGC|BGS|SGC|BVG|CSG)\b/i)?.[0] || "PSA");
  const m = raw.match(/(\d+(?:\.\d)?)(?!.*\d)/); // last number in the string
  return m ? `${company.toUpperCase()} ${m[1]}` : (raw || company.toUpperCase());
}
